
import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'AppSpamReportButton',
  emits: ['clicked', 'reported'],
  props: {
    spamReportableType: {
      type: String,
      default: 'review',
      validator: v => ['review', 'comment'].includes(v)
    },
    spamReportableId: {
      type: Number,
      required: true
    },
    isBlocked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['brandCode']),
    ...mapState('window', ['windowService']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('session', ['isLoggedIn'])
  },
  methods: {
    ...mapActions('widget', ['confirmForLogin']),
    ...mapActions('dialog', ['openSpamReportDialog']),
    onClickSpamReport() {
      this.$emit('clicked');

      if (!this.isLoggedIn) return this.confirmForLogin();

      if (!this.reviewSettings.enable_vue_widget_spam_reports_new) {
        return this.windowService.openFullscreenPopup(
          `/${this.brandCode}/mobile/spam_reports/new?article_blocked=${
            this.isBlocked
          }&selected_spam_type_tab=article&spam_reportable_id=${
            this.spamReportableId
          }&spam_reportable_type=${_.capitalize(
            this.spamReportableType
          )}&widget_env=100`
        );
      }

      return this.openSpamReportDialog({
        spamReportableId: this.spamReportableId,
        spamReportableType: _.capitalize(this.spamReportableType),
        articleBlocked: this.isBlocked
      }).then(response => {
        if (response) this.$emit('reported', response);
      });
    }
  }
};
